import { render, staticRenderFns } from "./select_prize&integral.vue?vue&type=template&id=f2afeff0&scoped=true"
import script from "./select_prize&integral.vue?vue&type=script&lang=js"
export * from "./select_prize&integral.vue?vue&type=script&lang=js"
import style0 from "./select_prize&integral.vue?vue&type=style&index=0&id=f2afeff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2afeff0",
  null
  
)

export default component.exports